import { useStrings } from "@/i18n/LocaleContext";

/**
 * "¿Por qué preguntamos esto?" rationale shown under a question that carries a
 * `whyWeAsk`. Rendered always-expanded (a plain block, not a click-gated
 * <details>) so the reassurance is visible without interaction. The label is
 * localized; the body text is per-question data.
 */
export function WhyWeAsk({ text }: { text: string }) {
  const t = useStrings();
  return (
    <div className="qk-why" data-qk-why>
      <p className="qk-why-label">{t.whyWeAsk}</p>
      <p className="qk-why-body">{text}</p>
    </div>
  );
}
